// Mirrors LABEL_COLOR_OPTIONS in chatwoot-mobile-app's
// src/components-next/label-section/labelColorOptions.ts, so a label's color
// looks the same whether created from web or mobile.
export const LABEL_COLOR_OPTIONS = [
  '#3B82F6',
  '#14B8A6',
  '#22C55E',
  '#84CC16',
  '#F59E0B',
  '#F97316',
  '#EF4444',
];

export const DEFAULT_LABEL_COLOR = LABEL_COLOR_OPTIONS[0];

export const getRandomColor = () =>
  LABEL_COLOR_OPTIONS[Math.floor(Math.random() * LABEL_COLOR_OPTIONS.length)];
